import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=e7377956&scoped=true"
import script from "./marketplace.vue?vue&type=script&lang=js"
export * from "./marketplace.vue?vue&type=script&lang=js"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=e7377956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7377956",
  null
  
)

export default component.exports